import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap, tap } from 'rxjs/operators';

import { RemoteConfigApi, RemoteConfigAppResponse } from '@vi-iot/client';

import { RemoteConfigActions } from './remote-config.actions';
import { ConfigurationStore } from '@store';

@Injectable()
export class RemoteConfigEffects {
  getRemoteConfig$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(RemoteConfigActions.getRemoteConfig),
      switchMap((action) =>
        this.api.getRemoteConfig(action.appId).pipe(
          // Temporary and needs to be deleted after backend's release
          // VIG-18502
          tap((response) => {
            if (response?.switchToClimateSolutionsDomain) {
              this.configurationStore.useClimateSolutionsDomain();
            }
          }),
          map((response: RemoteConfigAppResponse) =>
            RemoteConfigActions.getRemoteConfigSuccess({
              remoteConfig: response,
            })
          ),
          catchError((err) => {
            this.router.navigate(['/access-forbidden']);

            return of(RemoteConfigActions.getRemoteConfigError(err));
          })
        )
      )
    );
  });

  closeBanner$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(RemoteConfigActions.closeBanner),
      switchMap((action) => {
        localStorage.setItem(action.banner, 'true');

        return of(RemoteConfigActions.closeBannerSuccess({ banner: action.banner }));
      })
    );
  });

  constructor(
    private api: RemoteConfigApi,
    private actions$: Actions,
    private router: Router,
    private configurationStore: ConfigurationStore
  ) {}
}
